import { useState } from 'react';
import { useAcceptance } from '../../hooks/useAcceptance';
import { useAcceptanceData } from '../../hooks/useAcceptanceData';
import { useFullScreenModal } from '../../hooks/useFullScreenModal';

export function useSubscriptionTerms() {
  const [agree, setAgree] = useState(false);

  const {
    acceptance: acceptanceAgreement,
    isLoading: isLoadingAgreement,
    onAccept: onAcceptAgreement,
  } = useAcceptanceData('user_agreement');
  const {
    acceptance: acceptancePersonal,
    isLoading: isLoadingPersonal,
    onAccept: onAcceptPersonal,
  } = useAcceptanceData('personal_data_processing_policy');
  const [activeAcceptance, setActiveAcceptance] = useState(null);

  const disabled = isLoadingPersonal || isLoadingAgreement;

  const { Modal, setOpen } = useFullScreenModal({ onClose: () => setActiveAcceptance(null) });

  const openModalAcceptance = (type) => {
    if (!acceptanceAgreement || !acceptancePersonal) return;
    switch (type) {
      case 'user_agreement':
        setActiveAcceptance(acceptanceAgreement);
        setOpen(true);
        break;
      case 'personal_data_processing_policy':
        setActiveAcceptance(acceptancePersonal);
        setOpen(true);
      default:
        break;
    }
  };

  return {
    CheckBox: () => (
      <>
        <div className="flex justify-start items-start gap-[12px] mt-3">
          {agree ? (
            <img
              className="w-[24px] cursor-pointer pointer-events-auto shrink-0"
              alt="Checkbox"
              src={'/icons/famicons_checkbox.svg'}
              onClick={() => {
                setAgree(!agree);
                localStorage.setItem('user_agreement', 0);
                localStorage.setItem('personal_data_processing_policy', 0);
              }}
            />
          ) : (
            <div
              className="w-[24px] h-[24px] cursor-pointer border border-white rounded-[4px] pointer-events-auto shrink-0"
              alt="Checkbox"
              onClick={() => {
                setAgree(!agree);
                localStorage.setItem('user_agreement', 1);
                localStorage.setItem('personal_data_processing_policy', 1);
              }}
            />
          )}
          <p className="font-raleway font-medium text-xs text-white">
            Я принимаю условия{' '}
            <span
              onClick={() => openModalAcceptance('user_agreement')}
              className="underline text-[#A1F69E] cursor-pointer pointer-events-auto text-wrap"
            >
              Пользовательского соглашения
            </span>{' '}
            и даю согласие на{' '}
            <span
              onClick={() => openModalAcceptance('personal_data_processing_policy')}
              className="underline text-[#A1F69E] cursor-pointer pointer-events-auto text-wrap"
            >
              Обработку персональных данных
            </span>
          </p>
        </div>
        {activeAcceptance && (
          <Modal title={activeAcceptance.title}>
            <div className="whitespace-pre-line">{activeAcceptance.content}</div>
          </Modal>
        )}
      </>
    ),
    isChecked: agree,
  };
}
